import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import * as signalR from '@microsoft/signalr';

const SignalRContext = createContext(undefined);

export const SignalRProvider = ({ children }) => {
    const connection = useRef(null);
    const [messages, setMessages] = useState([]);
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        const websocketUrl = process.env.REACT_APP_WEBSOCKET_URL;
        if (!websocketUrl) {
            console.error("Missing REACT_APP_WEBSOCKET_URL environment variable");
            return;
        }

        connection.current = new signalR.HubConnectionBuilder()
            .withUrl(websocketUrl, {
                accessTokenFactory: () => localStorage.getItem('accessToken') || '',
                withCredentials: true,
            })
            .withAutomaticReconnect()
            .build();

        connection.current.onreconnecting(() => setIsConnected(false));
        connection.current.onreconnected(() => setIsConnected(true));
        connection.current.onclose(() => setIsConnected(false));

        connection.current
            .start()
            .then(() => setIsConnected(true))
            .catch(err => console.error('SignalR Connection Error: ', err));

        connection.current.on('ReceiveMessage', (message) => {
            console.log('new message', message);
            setMessages(prev => [...prev, message]);
        });

        return () => {
            if (connection.current) {
                connection.current.stop();
            }
        };
    }, []);

    return (
        <SignalRContext.Provider value={{ connection: connection.current, messages, isConnected }}>
            {children}
        </SignalRContext.Provider>
    );
};

export const useSignalR = () => {
    const context = useContext(SignalRContext);
    if (!context) {
        throw new Error('useSignalR must be used within a SignalRProvider');
    }
    return context;
};
